import { render, staticRenderFns } from "./marketStatistics.vue?vue&type=template&id=f8174fea"
import script from "./marketStatistics.vue?vue&type=script&lang=js"
export * from "./marketStatistics.vue?vue&type=script&lang=js"
import style0 from "./marketStatistics.vue?vue&type=style&index=0&id=f8174fea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports